/* eslint-disable */
import React, { useState } from "react";
import * as API from "../../../src/framework/API/api";
import { useEffect } from "react";
import { ApplicationConfigurationKeys, ENTITYNAME, LOCALSTORAGE_KEY, MEDIACATEGORIES, MEDIASUBCATEGORYTYPES, TOAST_TYPES } from "../../framework/constant/constant";
import SalesDashboardTile from "./SalesDashboardTile";
import { useTranslation } from "../../locale/useTranslation";
import { utility } from "../../framework/utility/utilityProvider";
import ToastNotification from "../../components/ToastNotification";

const ContentDashboard = () => {

  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const isRotana = company && company.Name && company.Name.toLowerCase() == "rotana";
  const showLimimtedMediaManagementMenu = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.ShowLimitedMediaManagementMenu) ?? false;

  const [dataCount , setDataCount ] = useState({
    programCount : 0,
    movieCount : 0,
    parentSeriesCount : 0,
    seriesCount : 0,
    commercialCount : 0,
    interstitialCount : 0,
    fillersCount : 0,
    musicCount : 0,
    playCount:0,
    ProgramsGenericCOUNT:0,
  })

  const [mediaSubCategoryTypeTile, setMediaSubCategoryTypeTile] = useState([]);
  const [mediaSubCategoryRes, setMediaSubCategoryRes] = useState([]);
  const lang = useTranslation();

  useEffect(() => {
    loadContentData();
  }, [])

  const loadContentData = async () => {

    let contentRes = await API.getContentCounts();
    let mediacategory = await API.getDataLookup(ENTITYNAME.MediaCategory, { sort: { SID: 1 } });
    let mediacategorysubtype = await API.getDataLookup(ENTITYNAME.MediaSubCategoryType, { sort: { SID: 1 } });
    let subcategoryTile = mediacategorysubtype.data.filter((x) => !mediacategory.data.some(m => m.Description === x.Description));
    setMediaSubCategoryTypeTile(subcategoryTile);
    if(contentRes.success){
      setMediaSubCategoryRes(contentRes?.data?.mediaSubCategory)      
      setDataCount({
        ...dataCount,
        
        programCount : contentRes?.data?.mediaCategory.find(x => x.SID === MEDIACATEGORIES.Program)?.count ?? 0,
        movieCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Movie)?.count ?? 0,
        commercialCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Commercial)?.count ?? 0,
        interstitialCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Interstitial)?.count ?? 0,
        fillersCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Filler)?.count ?? 0,
        musicCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Music)?.count ?? 0,
        parentSeriesCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Series)?.count ?? 0,
        seriesCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Season)?.count ?? 0,
        episodeCount : contentRes?.data?.mediaCategory.find(x=> x?.SID == MEDIACATEGORIES.Episode)?.count ?? 0,
      })
    }else{
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: contentRes.message });
    }

  };
  const tileColors = [
    "#1bcfcf",   // teal
    "#ff8c00",   // orange
    "#ff4f4f",   // red
    "#5e72e4",   // blue
    "#20c997",   // green
    "#6610f2",   // purple
  ];

  return (
    //<GlobalContext.Consumer>{item =>
      <div className="widget-body">
        <div className="row" style={{ marginLeft: "3px" }}>
          <div className={`salesDashboard_forCard col-sm-12 col-md-6 col-lg-${isRotana ? 4 : 3}`}>
            <SalesDashboardTile
              iconBackColor="#f58d05"
              count={dataCount.programCount}
              icon="fa-sharp fa-solid fa-computer"
              status={lang.program_label}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Program"
            />

          </div>
          <div className={`salesDashboard_forCard col-sm-12 col-md-6 col-lg-${isRotana ? 4 : 3}`}>
            <SalesDashboardTile
              iconBackColor="#1ca666"
              count={dataCount.movieCount}
              icon="fa-sharp fa-solid fa-film"
              status={lang.movie_label}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Movie"
            />
          </div>
          {!isRotana && <div className={`salesDashboard_forCard col-sm-12 col-md-6 col-lg-3`}>
            <SalesDashboardTile
              iconBackColor="#c72848"
              count={dataCount.parentSeriesCount}
              icon="fa-sharp fa-solid fa-compact-disc"
              status={lang.parent_series_lable}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Series"
            />
          </div>}
          <div className={`salesDashboard_forCard col-sm-12 col-md-6 col-lg-${isRotana ? 4 : 3}`}>
            <SalesDashboardTile
              iconBackColor="#3c83c9"
              count={dataCount.seriesCount}
              icon="fa-sharp fa-solid fa-peace"
              status={lang.series_only_label}
              description={lang.view_details_label}
              route= {isRotana && showLimimtedMediaManagementMenu ? "/home/MediaEpisode/SearchProgramByCategory" :"/home/MediaEpisode/Season" }
              filter={isRotana && showLimimtedMediaManagementMenu ? { mediaSubCategoryType : "Series" ?? "" } : {}}
            />
          </div>
        </div>
        <div className="row" style={{ marginLeft: "3px" }}>
          <div className="salesDashboard_forCard col-sm-12 col-md-6 col-lg-3">
            <SalesDashboardTile
              iconBackColor="#FA6166"
              count={dataCount.commercialCount}
              icon="fa-sharp fa-solid fa-cash-register"
              status={lang.commercial_label}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Commercial"
            />

          </div>
          <div className="salesDashboard_forCard col-sm-12 col-md-6 col-lg-3">
            <SalesDashboardTile
              iconBackColor="#FF69B3"
              count={dataCount.interstitialCount}
              icon="fa-sharp fa-solid fa-podcast"
              status={lang.interstitial_label}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Interstitial"
            />
          </div>
          <div className="salesDashboard_forCard col-sm-12 col-md-6 col-lg-3">
            <SalesDashboardTile
              iconBackColor="#98BC62"
              count={dataCount.fillersCount}
              icon="fa-sharp fa-solid fa-filter"
              status={lang.filler_label}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Filler"
            />
          </div>
          <div className="salesDashboard_forCard col-sm-12 col-md-6 col-lg-3">
            <SalesDashboardTile
              iconBackColor="#E3B448"
              count={dataCount.musicCount}
              icon="fa-sharp fa-solid fa-music"
              status={lang.music_label}
              description={lang.view_details_label}
              route="/home/MediaEpisode/Music"
            />
          </div>
        </div>

      {isRotana && showLimimtedMediaManagementMenu && <div className="row" style={{ marginLeft: "3px" }}>  
       {mediaSubCategoryTypeTile.length > 0 && mediaSubCategoryTypeTile.map((itemRes, index) => 
          <div className="salesDashboard_forCard col-sm-12 col-md-6 col-lg-3">
            <SalesDashboardTile
              iconBackColor={tileColors [index % tileColors.length]}
              count={mediaSubCategoryRes?.find(m => m.name === itemRes.Description)?.count ?? 0}
              icon="fa-sharp fa-solid fa-cash-register"
              status={itemRes.Description}
              description={lang.view_details_label}
              route="/home/MediaEpisode/SearchProgramByCategory"
              filter={{ mediaSubCategoryType : itemRes.Description ?? "" }}
            />
          </div>
       )}
       </div>}
      </div>
  );
};

export default ContentDashboard;
